<template>
  <div class="factory-switch" @click="switchFactory">
    <section class="factory-switch-inner">
      <span>{{ currentFactory.name }}</span>
      <icon-vue icon="icon-park-outline:switch" />
    </section>
  </div>
</template>

<script setup lang="ts">
import { showFactorySwitch, type Factory } from '@/components/widgets/factory-switch/config';
import { Icon as IconVue } from '@iconify/vue';
import { computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { factoryList, setFactoryCache } from '@/utils/factory';

const props = defineProps<{
  currentFactory: Factory;
}>();
const emit = defineEmits(['update:currentFactory']);

const { locale } = useI18n();

const currentFactory = computed({
  get: () => props.currentFactory,
  set: (factory: Factory) => {
    emit('update:currentFactory', factory);
  },
});

function switchFactory() {
  showFactorySwitch({
    onFactorySelect(factory: Factory) {
      currentFactory.value = factory;
    },
  });
}

// 监听语言变化，更新 currentFactory
watch(locale, (newLocale) => {
  if (newLocale === 'zh-CN') {
    const factory = factoryList.find((factory) => factory.id === 100);
    currentFactory.value = factory;
    setFactoryCache(factory);
  } else if (newLocale === 'th-TH') {
    const factory = factoryList.find((factory) => factory.id === 915);
    currentFactory.value = factory;
    setFactoryCache(factory);
  }
});
</script>

<style scoped>
.factory-switch {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  color: #86909c;
  font-size: 13px;
  transition: color 0.2s;
  user-select: none;
}

.factory-switch:hover {
  color: #fff;
}

.factory-switch-inner {
  display: flex;
  align-items: center;
  gap: 6px;
}
</style>
